import React, { useState, useEffect } from 'react';
import { useTimer } from 'use-timer';
//表示される数字、０埋めしている部分を灰色にする
const DisplayNumber = (props) => {
    if (String(props.number).length === 4) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(1)),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(2)),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(3))));
    }
    else if (String(props.number).length === 3) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(0)),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(1)),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(2))));
    }
    else if (String(props.number).length === 2) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-gray-300 w-16 text-right font-width-size-3-2" }, "0"),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(0)),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(1))));
    }
    else if (String(props.number).length === 1) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-gray-300 w-16 text-right font-width-size-3-2" }, "0"),
            React.createElement("div", { className: "text-gray-300 w-16 text-right font-width-size-3-2" }, "0"),
            React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, String(props.number).charAt(0))));
    }
    else {
        return (React.createElement(React.Fragment, null));
    }
};
const ShuffleNumber = (props) => {
    //実際の取得する数値
    const [number, setNumber] = useState(props.count ? props.count : 0);
    //一桁目の数字
    const [firstDigit, setFirstDigit] = useState(number >= 1 ? Math.floor(number) % 10 : 0);
    //二桁目の数字
    const [secondDigit, setSecondDigit] = useState(number / 10 >= 1 ? Math.floor(number / 10) % 10 : 0);
    //三桁目の数字
    const [thirdDigit, setThirdDigit] = useState(number / 100 >= 1 ? Math.floor(number / 100) % 10 : 0);
    //実際に表示する数字を管理するフラグ
    const [numberViewFlag, setNumberViewFlag] = useState(false);
    // タイマー
    const {} = useTimer({
        endTime: 20,
        autostart: true,
        interval: 70,
        onTimeUpdate: () => autoNumberShuffle(),
        onTimeOver: () => StopRandomAnimation(),
    });
    // 数値を0~9の間でシャッフルさせる
    const autoNumberShuffle = () => {
        setFirstDigit(randomNumber());
        setSecondDigit(randomNumber());
        setThirdDigit(randomNumber());
    };
    //タイマーが止められたら、数字のアニメーションを止める
    const StopRandomAnimation = () => {
        setNumberViewFlag(true);
    };
    // 0~9の間の数字をランダムで取得する関数
    const randomNumber = () => {
        const min = 0;
        const max = 9;
        return Math.floor(Math.random() * (max + 1 - min)) + min;
    };
    useEffect(() => {
        if (typeof props.count === "undefined") {
            const min = 1;
            const max = 999;
            const number = Math.floor(Math.random() * (max + 1 - min)) + min;
            setNumber(number);
        }
        else {
            setNumber(props.count);
            setFirstDigit(props.count >= 1 ? Math.floor(props.count) % 10 : 0);
            setSecondDigit(props.count / 10 >= 1 ? Math.floor(props.count / 10) % 10 : 0);
            setThirdDigit(props.count / 100 >= 1 ? Math.floor(props.count / 100) % 10 : 0);
        }
    }, [props.count]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flex justify-start" },
            React.createElement("h1", { className: `${props.resetClass ? props.resetClass : 'text-haikan-matching-red font-digital_font sm:text-6xl text-4xl sm:w-40 xs:w-36 w-24 font-bold  tracking-widest flex justify-between'}` }, numberViewFlag ?
                React.createElement(DisplayNumber, { number: number })
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, thirdDigit),
                        React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, secondDigit),
                        React.createElement("div", { className: "w-16 text-right font-width-size-3-2" }, firstDigit))))));
};
export default ShuffleNumber;
